const commissionReportFilters = {
  businessEntityId: null,
  userId: null,
  year: new Date().getFullYear(),
  month: new Date().getMonth() + 1
}

export default () => Object.assign({}, commissionReportFilters)
